<template>
  <div>
    <DemandMaterialTable :changeOrderCode="changeOrderCode" :disabled="disabled" />
  </div>
</template>

<script>
import DemandMaterialTable from './components/demand-material-table'
export default {
  components: {
    DemandMaterialTable,
  },
  props: {
    changeOrderCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
